import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import HomeService from "../../Services/HomeService";
import logo from "../../Images/build2.jpg";

export default function FutureDeveloper() {
  const [activeTab, setActiveTab] = useState({});
  const [dealerData, setDealerData] = useState([]);

  const fetchDealerSection = async () => {
    try {
      const res = await HomeService?.getDealerSection();

      console.log("Dealer Section API Response:", res);
      if (res?.status) {
        setDealerData(res?.data || []);

        // Initialize active tab for each dealer
        const initialActiveTabs = {};
        res.data.forEach((item, index) => {
          initialActiveTabs[item._id] = 0;
        });
        setActiveTab(initialActiveTabs);
      } else {
        console.log("API Error:", res);
      }
    } catch (error) {
      console.log("Error fetching dealer section:", error);
    }
  };

  useEffect(() => {
    fetchDealerSection();
  }, []);

  const settings = {
    dots: false,
    infinite: false,
    speed: 500,
    autoplaySpeed: 10500,
    autoplay: true,
    slidesToShow: Math.min(dealerData.length, 3),
    slidesToScroll: 1,
    arrows: true,
    // nextArrow: <SampleNextArrow />,
    // prevArrow: <SamplePrevArrow />,
    responsive: [
      {
        breakpoint: 1100,
        settings: {
          slidesToShow: Math.min(dealerData.length, 2),
        },
      },
      {
        breakpoint: 820,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  // Format price display
  const formatPrice = (price, priceUnit) => {
    if (!price || !priceUnit) return "Price on request";

    const priceNum = parseFloat(price);
    let formattedPrice = "";

    if (priceUnit === "CR") {
      formattedPrice = `₹${priceNum} Cr`;
    } else if (priceUnit === "LKH") {
      formattedPrice = `₹${priceNum} Lakh`;
    } else {
      formattedPrice = `₹${price} ${priceUnit}`;
    }

    return formattedPrice;
  };

  // Get first image from property
  const getPropertyImage = (property) => {
    if (property?.images && property.images.length > 0) {
      return property.images[0];
    }
    return logo; // fallback image
  };

  return (
    <div className="featured-container_fd">
      <h2 className="section-title_fd">
        <span>Featured Builders</span>
      </h2>
      <p className="section-subtitle_fd">
        Prominent real-estate builders & dealers
      </p>

      {dealerData.length > 0 ? (
        <Slider {...settings}>
          {dealerData?.map((item) => {
            const currentActiveTab = activeTab[item._id] || 0;
            const currentProperty = item?.properties?.[currentActiveTab];

            return (
              <div className="card_fd" key={item._id}>
                <div className="card-header_fd">
                  <div className="card-header_down_fd">
                    {/* Builder Logo - You can replace with actual logo if available */}
                    <div className="dev-logo-container_fd">
                      <img src={logo} alt="logo" className="dev-logo_fd" />
                    </div>
                    <div className="down_parts_fd">
                      <h3>{item.builderName || "Builder Name"}</h3>
                      <div className="year-projects_fd">
                        <div className="span_fd">
                          <p>Year estd.</p>
                          <span>{item.estdYear || "N/A"}</span>
                        </div>
                        <div className="span_fd">
                          <p>Projects</p>
                          <span>{item.totalProjects || "0"}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <p
                    className="desc_fd"
                    // style={{ overflowY: "auto", scrollbarWidth: "none" }}
                  >
                    {item.shortDescription || "No description available"}
                  </p>
                </div>

                {/* Property Tabs */}
                {item?.properties && item.properties.length > 0 ? (
                  <>
                    <div className="tabs_fd">
                      {item.properties.map((property, index) => (
                        <button
                          key={property._id || index}
                          className={
                            activeTab[item._id] === index
                              ? "tab_fd active"
                              : "tab_fd"
                          }
                          onClick={() =>
                            setActiveTab((prev) => ({
                              ...prev,
                              [item._id]: index,
                            }))
                          }
                          title={property.aptName || `Property ${index + 1}`}
                        >
                          {property.aptName
                            ? property.aptName.length > 14
                              ? property.aptName.slice(0, 14) + "..."
                              : property.aptName
                            : `Prop ${index + 1}`}
                        </button>
                      ))}
                    </div>

                    {/* Property Image and Details */}
                    <div className="tab-image_fd">
                      <img
                        style={{ cursor: "pointer" }}
                        src={getPropertyImage(currentProperty)}
                        alt={currentProperty?.aptName || "Property"}
                        onError={(e) => {
                          e.target.src = logo;
                        }}
                        onClick={() => {
                          localStorage.setItem(
                            "propertyId",
                            currentProperty?._id,
                          );
                          window.open("/single-property", "_blank");
                        }}
                      />
                      <div className="price-label_fd">
                        {/* {formatPrice(
                          currentProperty?.price,
                          currentProperty?.priceUnit
                        )} */}
                        ₹{currentProperty?.price}
                        {currentProperty?.priceUnit}
                      </div>

                      {/* Additional Property Info */}
                      {/* <div className="property-details_fd">
                        <div className="property-info_fd">
                          <span className="info-item_fd">
                            <i className="fas fa-bed"></i>
                            {currentProperty?.bhk || "N/A"} BHK
                          </span>
                          <span className="info-item_fd">
                            <i className="fas fa-layer-group"></i>
                            {currentProperty?.floor || "N/A"}
                          </span>
                          <span className="info-item_fd">
                            <i className="fas fa-ruler-combined"></i>
                            {currentProperty?.area || "N/A"}{" "}
                            {currentProperty?.unit || ""}
                          </span>
                        </div>
                        {currentProperty?.locality?.name && (
                          <div className="property-location_fd">
                            <i className="fas fa-map-marker-alt"></i>
                            {currentProperty.locality.name},{" "}
                            {currentProperty?.city?.name || ""}
                          </div>
                        )}
                      </div> */}
                    </div>
                  </>
                ) : (
                  <div className="no-properties_fd">
                    <p>No properties available</p>
                  </div>
                )}
              </div>
            );
          })}
        </Slider>
      ) : (
        <div className="no-data_fd">
          <p>No featured builders available at the moment.</p>
        </div>
      )}
    </div>
  );
}

function SampleNextArrow(props) {
  const { onClick } = props;
  return (
    <div className="arrow_ac arrow-right_ac" onClick={onClick}>
      <i className="fa-solid fa-arrow-right"></i>
    </div>
  );
}

function SamplePrevArrow(props) {
  const { onClick } = props;
  return (
    <div className="arrow_ac arrow-left_ac" onClick={onClick}>
      <i className="fa-solid fa-arrow-left"></i>
    </div>
  );
}
